import { faSparkles } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from 'cn';
import { useTranslations } from 'use-intl';

import type { ViewMode } from './survey-ai-forms.types';

interface Props {
  viewMode: ViewMode;
  onToggle: () => void;
}

export default function SurveyAiFormsModeToggle({ viewMode, onToggle }: Props) {
  const t = useTranslations('AIForms');

  const isAiMode = viewMode === 'ai';

  return (
    <button
      type='button'
      onClick={onToggle}
      data-ai-mode={isAiMode}
      data-test='mode-toggle'
      className='flex size-full cursor-pointer items-center rounded-[48px] p-1 transition-all duration-300 ease-in-out data-[ai-mode=false]:justify-start data-[ai-mode=false]:bg-gray-200 data-[ai-mode=true]:justify-end data-[ai-mode=true]:bg-(--brand-primary)'
      aria-label={
        viewMode === 'ai'
          ? t('modeToggle.switchToFormAria')
          : t('modeToggle.switchToAiAria')
      }
    >
      <div
        data-ai-mode={isAiMode}
        className='flex size-9 shrink-0 items-center justify-center rounded-full transition-all duration-300 ease-in-out data-[ai-mode=false]:bg-(--brand-primary) data-[ai-mode=true]:bg-white'
      >
        <FontAwesomeIcon
          icon={faSparkles}
          className={cn(
            'size-4',
            isAiMode ? 'text-black' : 'text-(--brand-primary-contrast)'
          )}
        />
      </div>
    </button>
  );
}
